import { getZombieInstanceFromPrimaryKey } from '@iotv/datamodel-core';
import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const AdminRedirectView = loadable(() => import('../components/SytemManagement/AdminRedirectView')).default;
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('AdminView own props', ownProps);
    const { id, type } = ownProps.params;
    const zombie = getZombieInstanceFromPrimaryKey(`${type}:${id}`);
    const contextObject = state.AppReducer.applicationData.getItem(zombie);
    return {
        user: state.AppReducer.user,
        contextCustomer: state.AppReducer.contextCustomer,
        contextObject,
        applicationData: state.AppReducer.applicationData,
        cognitoUser: state.AccessReducer.cognitoUser,
        userSelectedGroup: state.AppReducer.userSelectedGroup,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('AdminView Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AdminRedirectView);
